import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval, Subscription } from 'rxjs';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import * as $ from "jquery";
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { NearbyVehTripInfoComponent } from '../nearby-veh-trip-info/nearby-veh-trip-info.component';
declare let google: any;
declare let L;
import * as L from 'leaflet';


@Component({
  selector: 'app-panic-action-notification',
  templateUrl: './panic-action-notification.component.html',
  styleUrls: ['./panic-action-notification.component.scss']
})
export class PanicActionNotificationComponent implements OnInit, OnDestroy {

  mapCenter: any;
  tripListData: any[] = [];
  employeeStats: any[] = [];
  map: any = {};
  maps: any[] = [];
  marker: any;
  tripempmarkers: any = [];
  sitemarker: any;
  markers: any = [];
  colours = ["#4B0082"];
  sub: Subscription;
  isZoomed: Boolean = false;
  activatedEmpId: any;
  dialogData: any = {};
  panicActionData: any;
  currentUserId: any;
  reason: any;
  ltlngs = [];
  sortedWP = [];
  ivrSetupFlag: boolean = false;
  PanicUserId: any = '';
  private markers1: any[] = [];
  private vehicleMarkers: { [tripIndex: number]: L.Marker } = {};
  private pendingSosLocation: { latitude: number; longitude: number } | null = null;
  private pendingNearbyVehicles: any[] | null = null;
  showGoogleMap = false;
  isOsm = false;
  googleMapInitialized = false;
  mapInitialized = false;
  mapLoadAttempts = 0;
  maxMapLoadAttempts = 50;

  constructor(
    private serviceLocalStorage: ServiceLocalStorage,
    public dialogRef: MatDialogRef<PanicActionNotificationComponent>,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.initializeComponent(this.data);
  }

  initializeComponent(data: any): void {
    this.currentUserId = data.currentUserId;
    this.dialogData = data.tripData;
    this.panicActionData = data.panicActionData;
    this.tripListData = this.dialogData;
    this.calculateEmployees(this.dialogData);
    // if (data.mapType === AppConstants.OSRM) {
    //   this.map = {};
    //   setTimeout(() => this.initOsmMap(), 10);
    // } else {
    //   setTimeout(() => this.initMap(), 10);
    // }
    this.resolveMapTypeAndInit();

    this.PanicUserId = '';
    const isEmployee = data.panicActionData[0].activatedBy === "EMPLOYEE APP";
    const apiUrl = (isEmployee ? ApiConstants.getEmployeePanicbytripid : ApiConstants.getDriverPanicbytripId) + data.panicActionData[0].tripId.tripId;
    this.apiService.doGetRequestWithResponse(apiUrl, success => {
      if (success.status === 200 && success.body) {
        this.activatedEmpId = success.body[isEmployee ? 'employeeId' : 'driverId'];
        this.ivrSetupFlag = success.body.sosCallFlag;
        this.PanicUserId = success.body[isEmployee ? 'panicUserId' : 'panicId'];
        this.showSosLocation(success.body.lat, success.body.lng);
      } else {
        this.activatedEmpId = "";
        this.PanicUserId = '';
        this.ivrSetupFlag = false;
      }
    }, error => {
      this.notifyService.showError(error, null);
    });
  }

  updatePanicAction(): void {
    const panicData = this.panicActionData[0];
    panicData.alarmCause = this.reason;
    panicData.primaryActionTakenBy = { id: this.currentUserId };
    panicData.primaryAction = "Admin";
    this.ngxLoader.start();
    this.apiService.doPutRequestWithResponse(
      ApiConstants.updatePanicActionForAdmin + this.activatedEmpId,
      panicData,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.notifyService.showInfo(`Primary action taken by - ${success.body.curStatus} `, null);
        } else if (success.status === 204) {
          this.notifyService.showSuccess("Updated successfully", null);
          this.dialogRef.close("close");
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError(error, null);
      }
    );
  }

  // loadOSmap() {
  //   this.map = L.map("panicTripMap" + this.tripListData[0].tripDetails.tripId, {
  //     fullscreenControl: true
  //   }).setView([
  //     this.tripListData[0].tripDetails.site.landmark.latitude,
  //     this.tripListData[0].tripDetails.site.landmark.longitude
  //   ], 13);
  //   L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
  // }

  /** Uses client master-config flag (same as live-tracking / trip-list). */
  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.mapInitialized = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.isOsm) {
        this.map = {};
        this.initOsmMap();
      } else {
        this.loadgmap();
      }
    }, 10);
  }

  initOsmMap(): void {
    if (this.mapInitialized) {
      return;
    }

    const { tripId, site: { landmark } } = this.tripListData[0].tripDetails;
    const mapElement = document.getElementById(`panicTripMap${tripId}`);
    if (!mapElement) {
      setTimeout(() => this.initOsmMap(), 100);
      return;
    }

    this.map = L.map(`panicTripMap${tripId}`, { fullscreenControl: true })
      .setView([landmark.latitude, landmark.longitude], 13);
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
    this.mapInitialized = true;
    this.showTripOnOSMap();
    this.plotVehicle();
    this.applySosMarker();
    this.applyNearbyVehicleMarkers();
  }

  loadOSmap(): void {
    this.initOsmMap();
  }

  showTripOnOSMap(): void {
    const { tripDetails } = this.tripListData[0];
    if (!tripDetails.tripCode.includes('SPL')) {
      const { tripUsers, site, shift } = tripDetails;
      const siteLatLng = L.latLng(site.landmark.latitude, site.landmark.longitude);
      const userLatLngs = tripUsers.map(wp => L.latLng(wp.landmark.latitude, wp.landmark.longitude));
      const wps = shift.logType === "IN" ? [...userLatLngs, siteLatLng] : [siteLatLng, ...userLatLngs];

      const routing = L.Routing.control({
        serviceUrl: AppConstants.OSM_ROUTING_URL,
        showAlternatives: false,
        lineOptions: { styles: [{ color: "#242c81", weight: 7 }] },
        altLineOptions: { styles: [{ color: "#ed6852", weight: 3 }] },
        fitSelectedRoutes: true,
        waypointMode: "connect",
        addWaypoints: false,
        draggableWaypoints: false,
        autoRoute: true,
        reverseWaypoints: false,
        show: true,
        routeWhileDragging: false,
        createMarker: (i, wp) => this.createRouteMarker(i, wp, tripDetails)
      }).addTo(this.map);
      routing.setWaypoints(wps);
      routing.hide();
    }
  }

  createRouteMarker(i: number, wp: any, tripDetails: any): L.Marker | undefined {
    const { shift, tripUsers, site } = tripDetails;
    const isInbound = shift.logType === "IN";
    const isCompanyMarker = (isInbound && i === tripUsers.length) || (!isInbound && i === 0);
    if (isCompanyMarker) {
      return L.marker(wp.latLng, {
        icon: L.icon({ iconUrl: "./assets/images/company.png", iconSize: [40, 40] }),
        title: site.landmark.landmark
      });
    }
    const userIndex = isInbound ? i : i - 1;
    if (userIndex >= 0 && userIndex < tripUsers.length) {
      const user = tripUsers[userIndex].tripUser.userInfoDetails;
      const iconUrl = user.gender === "Female"
        ? "./assets/images/livetracking/femaleloc.svg"
        : "./assets/images/livetracking/maleloc.svg";

      return L.marker(wp.latLng, {
        icon: L.icon({ iconUrl, iconSize: [65, 70] }),
        title: user.displayName
      }).bindTooltip(`${isInbound ? i + 1 : i}`, {
        permanent: true,
        direction: "left",
        offset: L.point(-10, 0)
      }).openTooltip();
    }
  }

  initMap(): void {
    this.loadgmap();
  }

  loadgmap(): void {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.mapInitialized && this.maps?.length) {
      return;
    }
    if (!this.tripListData) {
      this.dialogRef.close("NoTrips");
      return;
    }
    const mapEl = document.getElementById(`panicTripMap${this.tripListData[0].tripDetails.tripId}`);
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry();
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry();
      return;
    }
    this.initGoogleMapAsync();
  }

  private scheduleGoogleMapLoadRetry(): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      return;
    }
    setTimeout(() => this.loadgmap(), 100);
  }

  private async initGoogleMapAsync(): Promise<void> {
    if (this.mapInitialized && this.maps?.length) {
      return;
    }
    try {
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry();
        return;
      }
      const { site: { landmark } } = this.tripListData[0].tripDetails;
      this.mapCenter = { lat: Number(landmark.latitude), lng: Number(landmark.longitude) };
      this.maps = this.tripListData.map((trip) => {
        const mapElement = document.getElementById(`panicTripMap${trip.tripDetails.tripId}`);
        if (!mapElement) {
          return null;
        }
        return new MapClass(mapElement, {
          center: this.mapCenter,
          zoom: 13,
          draggable: true,
          zoomControl: true,
          gestureHandling: 'greedy'
        });
      }).filter(Boolean);

      if (!this.maps.length) {
        this.scheduleGoogleMapLoadRetry();
        return;
      }

      this.mapInitialized = true;
      this.googleMapInitialized = true;
      this.maps.forEach((map, index) => {
        this.markSite(this.tripListData[0].tripDetails.site, index);
        google.maps.event.addListenerOnce(map, 'idle', () => {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(this.mapCenter);
        });
      });
      this.showRoutesOnMap();
      this.plotVehicle();
      this.applySosMarker();
      this.applyNearbyVehicleMarkers();
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry();
    }
  }

  // initMap(): void {
  //   if (this.mapInitialized) {
  //     return;
  //   }
  //   ... old sync google.maps.Map using data.mapType
  // }

  private isOsmMap(): boolean {
    return this.isOsm;
    // return this.data?.mapType === AppConstants.OSRM;
  }

  private getTripMapIndex(): number {
    const panicTripId = this.panicActionData?.[0]?.tripId?.tripId;
    if (!panicTripId) {
      return 0;
    }
    const index = this.tripListData.findIndex(trip => trip.tripDetails.tripId === panicTripId);
    return index >= 0 ? index : 0;
  }

  private getActiveLeafletMap(): any {
    return this.map?.addLayer ? this.map : null;
  }

  private getActiveGoogleMap(): any {
    const mapIndex = this.getTripMapIndex();
    return this.maps?.[mapIndex] || this.maps?.[0] || null;
  }

  plotVehicle(): void {
    this.getVehiclePosition(false);
    this.sub = interval(3000).subscribe(() => this.getVehiclePosition(true));
  }

  setZoomForCab(): void {
    this.maps.forEach((map, index) => {
      map.setCenter(this.markers[index].position);
      map.setZoom(17);
    });
    this.isZoomed = true;
  }

  getVehiclePosition(iterate: boolean): void {
    const _mCurrentUser: any = this.serviceLocalStorage.getUserObject();
    const body = { clientCode: _mCurrentUser.clientCode };
    this.tripListData.forEach((trip, index) => {
      // OSM keeps company maptype / OSRM; Google Maps flag sends GOOGLE GPS
      // const maptype = this.isOsmMap() ? this.serviceLocalStorage.maptype : AppConstants.OSRM;
      const maptype = this.isOsmMap() ? this.serviceLocalStorage.maptype : 'GOOGLE';
      const url = `fetchallgeoposition?tripId=${trip.tripDetails.tripId}&maptype=${maptype}`;
      this.apiService.doPostRequestWithResponseForLiveTracking(url, body,
        success => {
          if (!success.body) {
            return;
          }
          if (this.isOsmMap()) {
            this.plotVehicleMarkerOnOSmap(success.body, index);
          } else {
            iterate ? this.handleIterativeUpdate(success, index) : this.plotVehicleMarker(success.body, index);
          }
        },
        error => this.notifyService.showError(error, null)
      );
    });
  }

  handleIterativeUpdate(success: any, index: number): void {
    this.setVehiclePosition(success, index);
    if (!this.isZoomed) {
      this.setZoomForCab();
    }
  }

  /** Live-track API returns positionList (Google) or waypoints (OSRM). */
  private getVehiclePositions(veh: any): any[] {
    // Google maptype payload uses positionList + mobileTime, not waypoints/time
    // if (Array.isArray(veh?.waypoints) && veh.waypoints.length) {
    //   return veh.waypoints;
    // }
    if (Array.isArray(veh?.positionList) && veh.positionList.length) {
      return veh.positionList;
    }
    if (Array.isArray(veh?.waypoints) && veh.waypoints.length) {
      return veh.waypoints;
    }
    return [];
  }

  plotVehicleMarkerOnOSmap(veh: any, tripIndex: number): void {
    const waypoints = veh?.waypoints ?? veh?.positionList;
    if (!waypoints?.length) {
      return;
    }

    const lastWaypoint = waypoints[waypoints.length - 1];
    const position = [lastWaypoint.latitude, lastWaypoint.longitude];
    this.map.panTo(new L.LatLng(...position));
    if (this.vehicleMarkers[tripIndex]) {
      this.map.removeLayer(this.vehicleMarkers[tripIndex]);
    }

    const carMarker = new L.Icon({
      iconUrl: "./assets/images/livetracking/vehicle/FF503F.png",
      iconSize: [45, 40],
      iconAnchor: [15, 20]
    });
    this.vehicleMarkers[tripIndex] = L.marker(position, { icon: carMarker }).addTo(this.map);
  }

  plotVehicleMarker(veh: any, tripIndex: number): void {
    const positions = this.getVehiclePositions(veh);
    if (!positions.length || !this.maps[tripIndex]) {
      return;
    }
    const lastPosition = positions[positions.length - 1];
    const latlng = { lat: Number(lastPosition.latitude), lng: Number(lastPosition.longitude) };
    this.maps[tripIndex].panTo(latlng);
    const marker = new google.maps.Marker({
      position: latlng,
      animation: google.maps.Animation.DROP,
      draggable: false,
      icon: {
        url: `./assets/images/livetracking/vehicle/FF503F.png?id=${veh.tripId}`,
        scaledSize: new google.maps.Size(45, 40),
        anchor: new google.maps.Point(15, 20)
      },
      map: this.maps[tripIndex]
    });
    marker.customData = veh;
    this.markers.push(marker);
  }

  showRunningVehicle(data: any, tripIndex: number): void {
    const positions = this.getVehiclePositions(data.body);
    if (!positions.length) {
      return;
    }
    const lastPos = positions[positions.length - 1];
    const targetTripId = this.tripListData[tripIndex].tripDetails.tripId;
    const marker = this.markers.find(m => m.customData.tripId === targetTripId);
    if (marker) {
      const prevPosn = marker.getPosition();
      const newPosition = new google.maps.LatLng(lastPos.latitude, lastPos.longitude);
      const direction = this.computeHeadingDegrees(prevPosn, newPosition);
      marker.setPosition(newPosition);
      this.maps[tripIndex]?.panTo(newPosition);
      $(`img[src="./assets/images/livetracking/vehicle/FF503F.png?id=${data.body.tripId}"]`).css({
        transform: `rotate(${direction}deg)`,
        transition: "all 1s ease"
      });
      const icon = marker.getIcon();
      if (icon) {
        icon.rotation = direction;
        marker.setIcon(icon);
      }
    }
    this.fetchETA(tripIndex, positions);
  }

  private computeHeadingDegrees(from: any, to: any): number {
    const lat1 = (typeof from.lat === 'function' ? from.lat() : from.lat) * Math.PI / 180;
    const lat2 = (typeof to.lat === 'function' ? to.lat() : to.lat) * Math.PI / 180;
    const dLng = ((typeof to.lng === 'function' ? to.lng() : to.lng) -
      (typeof from.lng === 'function' ? from.lng() : from.lng)) * Math.PI / 180;
    const y = Math.sin(dLng) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
    return (Math.atan2(y, x) * 180 / Math.PI + 360) % 360;
  }

  fetchETA(tripIndex: number, vehiclePos: any[]): void {
    const { tripDetails } = this.tripListData[tripIndex];
    const { tripUsers, site, shift, tripId } = tripDetails;
    const lastVehiclePos = vehiclePos[vehiclePos.length - 1];
    const getDestination = () => {
      if (shift.logType === "IN") {
        const firstUser = tripUsers[0];
        return firstUser ? firstUser.landmark : site.landmark;
      }
      return tripUsers[tripUsers.length - 1].landmark;
    };

    const destination = getDestination();
    const body = {
      tripid: tripId,
      srcLat: lastVehiclePos.latitude,
      srcLong: lastVehiclePos.longitude,
      destLat: destination.latitude,
      destLong: destination.longitude
    };

    this.apiService.doPostRequestWithResponse(ApiConstants.fetcheta, body,
      success => {
        if (success.body.tripid === tripId) {
          const trip = this.tripListData[tripIndex];
          const { body: responseBody } = success;
          trip.etaKm = responseBody.distance || 0;
          trip.etaMin = responseBody.time || "NA";
          trip.consumedMin = responseBody.timeElapsed?.slice(3, 8) || "NA";
          trip.consumedKm = responseBody.distanceCovered || 0;
          trip.lateTime = responseBody.lateTime || 0;
        }
      },
      error => this.notifyService.showError(error, null)
    );
  }

  setVehiclePositionOnOSmap(data: any, tripIndex: number): void {
    if (!data.body) return;
    this.showRunningVehicle(data, tripIndex);
    const vehiclePlanCoordinates = data.body.positionList.map(vehicle => ({
      lat: vehicle.latitude,
      lng: vehicle.longitude
    }));

    new google.maps.Polyline({
      path: vehiclePlanCoordinates,
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 2
    }).setMap(this.maps[tripIndex]);
  }

  setVehiclePosition(data: any, tripIndex: number): void {
    if (!data.body) return;
    this.showRunningVehicle(data, tripIndex);
    const positions = this.getVehiclePositions(data.body);
    const vehiclePlanCoordinates = positions.map(vehicle => ({
      lat: vehicle.latitude,
      lng: vehicle.longitude
    }));
    if (!vehiclePlanCoordinates.length) {
      return;
    }

    new google.maps.Polyline({
      path: vehiclePlanCoordinates,
      geodesic: true,
      strokeColor: "#FF0000",
      strokeOpacity: 1.0,
      strokeWeight: 2
    }).setMap(this.maps[tripIndex]);
  }

  showRoutesOnMap() {
    this.tripListData.forEach((trip, t) => {
      if (trip.tripDetails.tripCode?.includes('SPL')) {
        return;
      }
      let waypts = [];
      let startnodelatlng = {
        lat: trip.tripDetails.site.landmark.latitude,
        lng: trip.tripDetails.site.landmark.longitude
      };
      let endnodelatlng = {
        lat: trip.tripDetails.site.landmark.latitude,
        lng: trip.tripDetails.site.landmark.longitude
      };
      if (trip.tripDetails.shift) {
        if (trip.tripDetails.shift.logType == "IN") {
          startnodelatlng = {
            lat: trip.tripDetails.tripUsers[0] ? trip.tripDetails.tripUsers[0].showStatus == "SHOW" ? trip.tripDetails.tripUsers[0].booardedLatitude
              ? trip.tripDetails.tripUsers[0].booardedLatitude : trip.tripDetails.tripUsers[0].landmark.latitude
              : trip.tripDetails.tripUsers[0].landmark.latitude : trip.tripDetails.site.landmark.latitude,
            lng: trip.tripDetails.tripUsers[0] ? trip.tripDetails.tripUsers[0].showStatus == "SHOW" ? trip.tripDetails.tripUsers[0].booardedLongitude
              ? trip.tripDetails.tripUsers[0].booardedLongitude : trip.tripDetails.tripUsers[0].landmark.longitude
              : trip.tripDetails.tripUsers[0].landmark.longitude : trip.tripDetails.site.landmark.longitude
          };
        } else {
          const tripLength = trip.tripDetails.tripUsers.length - 1;
          endnodelatlng = {
            lat: trip.tripDetails.tripUsers[tripLength].showStatus == "SHOW" ? trip.tripDetails.tripUsers[tripLength].arrivalLatitude
              ? trip.tripDetails.tripUsers[tripLength].arrivalLatitude : trip.tripDetails.tripUsers[tripLength].landmark.latitude
              : trip.tripDetails.tripUsers[tripLength].landmark.latitude,
            lng: trip.tripDetails.tripUsers[tripLength].showStatus == "SHOW" ? trip.tripDetails.tripUsers[tripLength].arrivalLongitude
              ? trip.tripDetails.tripUsers[tripLength].arrivalLongitude : trip.tripDetails.tripUsers[tripLength].landmark.longitude
              : trip.tripDetails.tripUsers[tripLength].landmark.longitude
          };
        }
      }
      let markerlist = [];
      trip.tripDetails.tripUsers.forEach((tripuser, tIndex) => {
        waypts.push({
          location: {
            lat: tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLatitude ? tripuser.booardedLatitude
              : tripuser.landmark.latitude : tripuser.landmark.latitude,
            lng: tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLongitude ? tripuser.booardedLongitude
              : tripuser.landmark.longitude : tripuser.landmark.longitude
          },
          stopover: true
        });
        const empLat = tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLatitude ? tripuser.booardedLatitude
          : tripuser.landmark.latitude : tripuser.landmark.latitude;
        const empLng = tripuser.showStatus == "SHOW" && trip.tripDetails.shift.logType == "IN" ? tripuser.booardedLongitude ? tripuser.booardedLongitude
          : tripuser.landmark.longitude : tripuser.landmark.longitude;
        const iconUrl = tripuser.tripUser.userInfoDetails.gender == "Female"
          ? "./assets/images/livetracking/femaleloc.svg"
          : "./assets/images/livetracking/maleloc.svg";
        var marker = new google.maps.Marker({
          position: { lat: empLat, lng: empLng },
          icon: {
            url: iconUrl,
            scaledSize: new google.maps.Size(40, 44),
            anchor: new google.maps.Point(20, 44)
          },
          draggable: false,
          map: this.maps[t],
          title: tripuser.tripUser.userInfoDetails.displayName + " - " + tripuser.routedOrder
        });
        marker.customData = {
          tripId: trip.tripDetails.tripId,
          tripIndex: t,
          logType: trip.tripDetails.shift.logType,
          userId: tripuser.tripUser.userInfoDetails.id,
          tripUser: tripuser
        };
        const orderLabel = String(tIndex + 1);
        this.createOsmLikeLabel(this.maps[t], { lat: empLat, lng: empLng }, orderLabel, 'left');
        google.maps.event.addListener(marker, "click", () => {
          this.fetchUserHomePickup(marker.customData);
        });
        markerlist.push(marker);
      });
      this.tripempmarkers.push({
        tripid: trip.tripDetails.tripId,
        markers: markerlist
      });
      if (this.sitemarker == undefined) {
        this.markSite(trip.tripDetails.site, t);
      }
      const isInTrip = trip.tripDetails.shift?.logType == "IN";
      // Exclude origin/destination from waypoints — duplicating them skews Google Directions.
      const middleWaypts = isInTrip ? waypts.slice(1) : waypts.slice(0, -1);
      let request = {
        origin: startnodelatlng,
        destination: endnodelatlng,
        waypoints: middleWaypts,
        optimizeWaypoints: false,
        avoidHighways: false,
        avoidTolls: false,
        travelMode: google.maps.DirectionsTravelMode.DRIVING
      };
      let directionsService = new google.maps.DirectionsService();
      let directionsDisplay = new google.maps.DirectionsRenderer({
        polylineOptions: {
          strokeColor: "#242c81",
          strokeWeight: 7,
          strokeOpacity: 1
        }
      });
      directionsDisplay.setMap(this.maps[t]);
      directionsDisplay.setOptions({ suppressMarkers: true });
      directionsService.route(request, (response, status) => {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        }
      });
    });
  }

  fetchUserHomePickup(userData: any): void {
    const url = `${ApiConstants.fetchuserhomepickup}${userData.tripId}&userId=${userData.userId}&logType=${userData.logType}`;
    this.apiService.doGetRequestWithResponse(url,
      success => {
        this.setPickupPoint(userData, success.body);
        this.setHomePoint(userData, success.body);
      },
      error => this.notifyService.showError(error, null)
    );
  }

  setHomePoint(userData, data) {
    this.addMarker(userData, data, "home");
    this.setRoute(userData, data, "home");
  }

  setPickupPoint(userData, data) {
    this.addMarker(userData, data, "pickup");
    this.setRoute(userData, data, "pickup");
  }

  addMarker(userData: any, data: any, type: "home" | "pickup"): void {
    const landmark = type === "home" ? data.homeLandmark : data.pickupLandmark;
    const iconUrl = type === "home" ? "./assets/images/home.png" : "./assets/images/livetracking/driver.png";
    new google.maps.Marker({
      position: { lat: landmark.latitude, lng: landmark.longitude },
      icon: iconUrl,
      draggable: false,
      map: this.maps[userData.tripIndex],
      title: data.homeLandmark.area.area
    });
  }

  setRoute(userData: any, data: any, type: "home" | "pickup"): void {
    const { tripUser } = userData;
    const isShow = tripUser.showStatus === "SHOW";
    const landmark = type === "home" ? data.homeLandmark : data.pickupLandmark;
    const origin = {
      lat: isShow ? (tripUser.booardedLatitude || tripUser.landmark.latitude) : tripUser.landmark.latitude,
      lng: isShow ? (tripUser.booardedLongitude || tripUser.landmark.longitude) : tripUser.landmark.longitude
    };

    const destination = { lat: landmark.latitude, lng: landmark.longitude };
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      preserveViewport: true,
      polylineOptions: {
        strokeColor: type === "home" ? "#080" : "#800",
        strokeWeight: 3,
        strokeOpacity: 0.7
      }
    });

    directionsDisplay.setMap(this.maps[userData.tripIndex]);
    directionsDisplay.setOptions({ suppressMarkers: true });
    directionsService.route({
      origin,
      destination,
      waypoints: [],
      optimizeWaypoints: false,
      avoidHighways: false,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, (response, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        directionsDisplay.setDirections(response);
      }
    });
  }

  markSite(site: any, mapIndex: number): void {
    this.sitemarker = new google.maps.Marker({
      position: { lat: site.landmark.latitude, lng: site.landmark.longitude },
      icon: {
        url: "./assets/images/company.png",
        scaledSize: new google.maps.Size(40, 40)
      },
      map: this.maps[mapIndex],
      title: site.siteName
    });
  }

  calculateEmployees(trips: any[]): void {
    this.employeeStats = trips.map(trip => {
      const stats = {
        femaleEmployees: 0,
        maleEmployees: 0,
        totalEmployees: trip.tripDetails.tripUsers.length,
        femaleShowStats: 0,
        maleShowStats: 0,
        femaleNoShowStats: 0,
        maleNoShowStats: 0,
        currentLocationPin: 0
      };
      trip.tripDetails.tripUsers.forEach((emp, index) => {
        const { gender } = emp.tripUser.userInfoDetails;
        const { showStatus } = emp;
        const isFemale = gender === "Female";
        if (showStatus === "SHOW") {
          stats.currentLocationPin = index + 1;
          isFemale ? stats.femaleShowStats++ : stats.maleShowStats++;
        } else if (showStatus === "NO SHOW") {
          isFemale ? stats.femaleNoShowStats++ : stats.maleNoShowStats++;
        }
        isFemale ? stats.femaleEmployees++ : stats.maleEmployees++;
      });
      return stats;
    });
  }

  showSosLocation(latitude: number, longitude: number): void {
    this.pendingSosLocation = { latitude, longitude };
    this.applySosMarker();
  }

  private applySosMarker(): void {
    if (!this.pendingSosLocation) {
      return;
    }

    const { latitude, longitude } = this.pendingSosLocation;

    if (this.isOsmMap()) {
      const map = this.getActiveLeafletMap();
      if (!map) {
        return;
      }

      if (this.marker?.remove) {
        map.removeLayer(this.marker);
      }

      this.marker = L.marker([latitude, longitude], {
        icon: new L.Icon({
          iconUrl: './assets/images/sos.svg',
          iconSize: [80, 80],
          iconAnchor: [33, 73]
        })
      }).addTo(map);
      map.setView([latitude, longitude], map.getZoom());
      return;
    }

    const googleMap = this.getActiveGoogleMap();
    if (!googleMap) {
      return;
    }

    if (this.marker?.setMap) {
      this.marker.setMap(null);
    }

    this.marker = new google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      icon: {
        url: './assets/images/sos.svg',
        scaledSize: new google.maps.Size(80, 80),
        anchor: new google.maps.Point(33, 73)
      },
      map: googleMap
    });
    googleMap.setCenter({ lat: latitude, lng: longitude });
  }

  doIVRCall(tripUserId: string, tripId: string, empType: string): void {
    this.ngxLoader.start();
    const paramMap = {
      'driver': 'driverId',
      'escort': 'escortId'
    };

    const paramName = paramMap[empType] || 'tripUserId';
    const url = `${ApiConstants.ivrEmpCall}${tripId}&${paramName}=${tripUserId}`;
    this.apiService.doPostRequestWithResponse(url, '',
      success => this.ngxLoader.stop(),
      error => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  showNearByVehicle(): void {
    this.ngxLoader.start();
    const isEmployeeApp = this.data.panicActionData[0].activatedBy === 'EMPLOYEE APP';
    const baseUrl = `${ApiConstants.showNearByVehile}${this.panicActionData[0].tripId.tripId}`;
    const url = isEmployeeApp ? `${baseUrl}&userId=${this.PanicUserId}` : baseUrl;
    this.apiService.doGetRequestWithResponse(url,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          const vehicles = this.parseNearbyVehiclesResponse(success.body);
          this.clearMarkers();
          if (vehicles.length > 0) {
            this.pendingNearbyVehicles = vehicles;
            this.applyNearbyVehicleMarkers();
          } else {
            this.notifyService.showInfo('No vehicle found within a 2KM radius.', null);
          }
        } else {
          this.notifyService.showInfo('No vehicle found within a 2KM radius.', null);
        }
      },
      error => this.ngxLoader.stop()
    );
  }

  private parseNearbyVehiclesResponse(body: any): any[] {
    if (Array.isArray(body)) {
      return body;
    }
    if (Array.isArray(body?.data)) {
      return body.data;
    }
    return [];
  }

  private applyNearbyVehicleMarkers(): void {
    if (!this.pendingNearbyVehicles?.length) {
      return;
    }

    const vehicles = this.pendingNearbyVehicles;
    if (this.isOsmMap()) {
      if (!this.getActiveLeafletMap()) {
        return;
      }
    } else if (!this.getActiveGoogleMap()) {
      return;
    }

    this.addVehicleMarkers(vehicles);
    this.pendingNearbyVehicles = null;
  }

  addVehicleMarkers(vehicles: any[]): void {
    if (this.isOsmMap()) {
      this.addOsmVehicleMarkers(vehicles);
      return;
    }
    this.addGoogleVehicleMarkers(vehicles);
  }

  private addOsmVehicleMarkers(vehicles: any[]): void {
    const map = this.getActiveLeafletMap();
    if (!map) {
      return;
    }

    const latLngs: L.LatLng[] = [];
    vehicles.forEach(vehicle => {
      const lat = Number(vehicle.latitude);
      const lng = Number(vehicle.longitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }

      const latLng = L.latLng(lat, lng);
      latLngs.push(latLng);
      const marker = L.marker(latLng, {
        icon: new L.Icon({
          iconUrl: './assets/images/livetracking/vehicle/843C0C.png',
          iconSize: [45, 40],
          iconAnchor: [15, 20]
        })
      })
        .addTo(map)
        .bindPopup(
          $(`<b style="cursor:pointer">${vehicle.vehicleNo}</b>`).click(() => {
            this.showVehicleInfo(vehicle.tripId);
          })[0]
        );

      this.markers1.push(marker);
    });

    if (latLngs.length) {
      map.fitBounds(L.latLngBounds(latLngs), { padding: [40, 40] });
    }
  }

  private addGoogleVehicleMarkers(vehicles: any[]): void {
    const map = this.getActiveGoogleMap();
    if (!map) {
      return;
    }

    const bounds = new google.maps.LatLngBounds();
    vehicles.forEach(vehicle => {
      const lat = Number(vehicle.latitude);
      const lng = Number(vehicle.longitude);
      if (Number.isNaN(lat) || Number.isNaN(lng)) {
        return;
      }

      const position = { lat, lng };
      bounds.extend(position);
      const marker = new google.maps.Marker({
        position,
        icon: {
          url: './assets/images/livetracking/vehicle/843C0C.png',
          scaledSize: new google.maps.Size(45, 40),
          anchor: new google.maps.Point(15, 20)
        },
        map
      });

      const infoWindow = new google.maps.InfoWindow({
        content: `<b style="cursor:pointer" id="nearby-veh-${vehicle.tripId}">${vehicle.vehicleNo}</b>`
      });

      google.maps.event.addListener(infoWindow, 'domready', () => {
        document.getElementById(`nearby-veh-${vehicle.tripId}`)?.addEventListener('click', () => {
          this.showVehicleInfo(vehicle.tripId);
        });
      });

      google.maps.event.addListener(marker, 'click', () => {
        infoWindow.open(map, marker);
      });
      marker.osmLabel = this.createOsmLikeLabel(map, position, vehicle.vehicleNo || '', 'top', () => {
        infoWindow.open(map, marker);
        this.showVehicleInfo(vehicle.tripId);
      });

      this.markers1.push(marker);
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
      google.maps.event.trigger(map, 'resize');
    }
  }

  clearMarkers(): void {
    if (this.isOsmMap()) {
      const map = this.getActiveLeafletMap();
      if (map) {
        this.markers1.forEach(marker => map.removeLayer(marker));
      }
    } else {
      this.markers1.forEach(marker => {
        marker?.osmLabel?.setMap?.(null);
        marker?.setMap?.(null);
      });
    }
    this.markers1 = [];
  }

  showVehicleInfo(tripId) {
    let sentData = {
      tripId: tripId,
      ivrSetupFlag: this.ivrSetupFlag
    }
    let dialogRef = this.dialog.open(NearbyVehTripInfoComponent, {
      width: "700px",
      data: sentData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  /** Leaflet-style permanent tooltip (stop numbers / vehicle labels) on Google Maps. */
  private createOsmLikeLabel(
    map: any,
    position: { lat: number; lng: number },
    text: string,
    placement: 'left' | 'top' = 'top',
    onClick?: () => void
  ): any {
    if (!map || !google?.maps?.OverlayView || !text) {
      return null;
    }
    const Overlay = google.maps.OverlayView;
    class OsmLikeLabel extends Overlay {
      div: HTMLDivElement | null = null;
      pos: any;
      labelText: string;
      labelPlacement: 'left' | 'top';
      clickHandler?: () => void;

      constructor(pos: any, labelText: string, labelPlacement: 'left' | 'top', clickHandler?: () => void) {
        super();
        this.pos = pos;
        this.labelText = labelText;
        this.labelPlacement = labelPlacement;
        this.clickHandler = clickHandler;
      }

      onAdd() {
        const div = document.createElement('div');
        div.className = this.labelPlacement === 'left'
          ? 'gm-leaflet-tooltip gm-leaflet-tooltip-left'
          : 'gm-leaflet-tooltip gm-leaflet-tooltip-top';
        const safe = String(this.labelText || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        div.innerHTML = `<b>${safe}</b>`;
        if (this.clickHandler) {
          div.addEventListener('click', (e) => {
            e.stopPropagation();
            this.clickHandler();
          });
        }
        this.div = div;
        this.getPanes()?.overlayMouseTarget?.appendChild(div);
      }

      draw() {
        if (!this.div) return;
        const projection = this.getProjection();
        if (!projection) return;
        const point = projection.fromLatLngToDivPixel(this.pos);
        if (!point) return;
        this.div.style.left = `${point.x}px`;
        this.div.style.top = this.labelPlacement === 'left'
          ? `${point.y - 22}px`
          : `${point.y - 20}px`;
      }

      onRemove() {
        if (this.div?.parentNode) {
          this.div.parentNode.removeChild(this.div);
        }
        this.div = null;
      }
    }

    const overlay = new OsmLikeLabel(
      new google.maps.LatLng(position.lat, position.lng),
      text,
      placement,
      onClick
    );
    overlay.setMap(map);
    return overlay;
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

}
